module.exports = __webpack_public_path__ + "static/media/2.1164a803.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Schokwave/Images/2.png
// module id = 693
// module chunks = 0